import { empty } from 'views/components/php.js';

function decode_telefono(tel = '{}') {
    const aux = JSON.parse(tel);
    return !empty(aux.tel) ? aux : { tel: '', tipo: 'tel. fijo' };
}

function decode_empresa_datos(emp) {
    if (!empty(emp.telefono1)) {
        emp.telefono1 = decode_telefono(emp.telefono1);
    }
    if (!empty(emp.telefono2)) {
        emp.telefono2 = decode_telefono(emp.telefono2);
    }

    return emp;
}

function get_empresa_datos_vacio() {
    return {
        telefono1: decode_telefono(),
        telefono2: decode_telefono()
    };
}

export {
    decode_empresa_datos,
    get_empresa_datos_vacio
};
